import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import styles from './HorizontalScrollWithFade.module.scss';

const SCROLL_HINT_FADE_AT = 100;

interface HorizontalScrollWithFadeProps {
  children: React.ReactNode;
  hasBottomBorder?: boolean;
}

const HorizontalScrollWithFade = ({
  children,
  hasBottomBorder = false,
}: HorizontalScrollWithFadeProps) => {
  const [opacity, setOpacity] = useState(0);
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Add boolean prefix next time file is edited
  const [scrollable, setScrollable] = useState(false);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const calculate = () => {
    if (!scrollContainerRef.current) return;
    const { scrollWidth, clientWidth, scrollLeft } = scrollContainerRef.current;
    const overflowWidth = scrollWidth - clientWidth;
    setScrollable(overflowWidth > 0);
    const leftToScroll = overflowWidth - scrollLeft;
    const fadeThreshold = Math.min(SCROLL_HINT_FADE_AT, overflowWidth);
    const newOpacity = Math.min(1, leftToScroll / fadeThreshold);
    setOpacity(newOpacity);
  };

  useEffect(calculate, [children]);

  return (
    <div
      className={classNames(styles.container, {
        [styles.hasBottomBorder]: hasBottomBorder,
      })}
    >
      <div
        className={styles.children}
        onScroll={calculate}
        ref={scrollContainerRef}
      >
        {scrollable ? (
          <div className={styles.scrollWrapper}>{children}</div>
        ) : (
          children
        )}
      </div>
      <div
        className={styles.scrollHint}
        style={{
          background: `linear-gradient(90deg, rgba(var(--color-gray-10-rgb), 0) 0%, rgba(var(--color-gray-10-rgb), ${opacity}) 99%)`,
        }}
      />
    </div>
  );
};

export default HorizontalScrollWithFade;
